import { HttpMethod, MockEndpointConfig } from './types'

const NOT_INTEGRATED_ENDPOINTS: { path: string; method: HttpMethod[] }[] = []

const matchPath = (path: string, inputPath: string) => {
    const pathRegex = new RegExp(
        `^${inputPath.replace(/:([a-zA-Z]+)/g, '[^/]+')}$`
    )
    return pathRegex.test(path)
}

export const isApiEndpointMocked = (request: MockEndpointConfig) => {
    if (import.meta.env.VITE_USE_MOCK === 'true') {
        return true
    }

    // Special case for specific report types that should use real API
    if (
        request.path &&
        (request.path.includes('/reports/usage-cost') ||
            request.path.includes('/reports/payables-summary'))
    ) {
        return false
    }

    return NOT_INTEGRATED_ENDPOINTS.some((input) => {
        const methodMatches = input.method.includes(request.method)

        const pathMatches =
            input.path && request.path && matchPath(request.path, input.path)

        return methodMatches && pathMatches
    })
}
